module.exports = __webpack_public_path__ + "img/beNull.3fe758da.png";